import {
  UpgradeUserPlanInterface,
  UpgradeUserPlanResponseInterface,
} from 'modules/profile/user-plan/types/user-plan-interface'
import httpClient from 'shared/utils/http-client'

export const USER_PLAN_API = '/api/dashboard/customer/settings/user-plan'
export const USER_PLAN_V2_API = `${USER_PLAN_API}/v2`

export const updateUserPlan = (data: UpgradeUserPlanInterface) =>
  httpClient.post<UpgradeUserPlanResponseInterface>(`${USER_PLAN_API}/upgrade`, data)
